import { wrap } from "../rill/RillReact";
import Page from "./page";
import Dashboard from "./dashboard";
import AthletePortal from "./athlete-portal";
import CoachingPortal from "./coaching-portal";
import Share from "./share";

const Wrappers = (app) => {
  app
    .get("/*", wrap(Page))
    .get("/admin/*", wrap(Dashboard))
    .get("/dashboard/*", wrap(Dashboard))
    .get("/athlete-portal/*", wrap(AthletePortal))
    .get("/coaching-portal/*", wrap(CoachingPortal))
    .get("/share/*", wrap(Share));
};

export default Wrappers;
